import { Input } from 'rsuite'
import { getIn } from 'formik'
import { FormikInputs } from './interfaces'
import './TextInput.scss'

function TextInput<V>(props: Readonly<FormikInputs<V>>): React.ReactElement {
  const {
    formik,
    dataType = 'string',
    placeholder = '',
    isDisabled,
    name,
    className,
    ...rest
  } = props

  const fieldValue = getIn(formik?.values, name) ?? ''

  return (
    <Input
      className={`shared-text-input ${className ?? ''}`}
      name={name}
      data-testid={name}
      type={dataType}
      value={
        typeof fieldValue === 'string' || typeof fieldValue === 'number'
          ? fieldValue
          : ''
      }
      disabled={isDisabled}
      placeholder={placeholder}
      onChange={(value: string) => {
        formik?.setFieldValue(name, value)
        formik?.setFieldTouched(name, true, false)
      }}
      {...rest}
    />
  )
}

export default TextInput
